import { z } from "zod";

const uuidSchema = z.uuidv4();

export const isUUID = (value: string | null): boolean => {
  return uuidSchema.safeParse(value).success;
};
